import React from 'react';
import { useTranslation } from 'react-i18next';



export default function OrderDeliveryDate({ order_delivery_date }) {
  
  const { t } = useTranslation();
  
  function formatDate(dateString) {
    
    const date = new Date(`${dateString}Z`);
    if (isNaN(date.getTime())) {
      return "---";
    }
  
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
  
    const months = [
      t('january'), t('february'), t('march'), t('april'), t('may'), t('june'),
      t('july'), t('august'), t('september'), t('october'), t('november'), t('december')
    ];
  
    return `${day} ${months[month]} ${year}`;
  }
  
  const formattedDate = formatDate(order_delivery_date);

  return (
    <div className='rounded-full text-xs h-7 items-center leading-7'>{formattedDate}</div>
  )
}